import { ROUTES } from 'constant';
import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';

import { Box, Flex, Stack, Text, useTheme } from '@chakra-ui/react';

import { formatCurrency } from 'utils';

interface GiftCardBlockProps {
  title: string;
  amount: string | number;
  image: StaticImageData;
  isAlternativeVariant: boolean;
}

const GiftCardBlock = ({
  title,
  amount,
  image,
  isAlternativeVariant
}: GiftCardBlockProps) => {
  const {
    colors: {
      palette: {
        components: { giftCardBlock }
      }
    }
  } = useTheme();
  const giftCardText = typeof amount === 'string';
  const isEmpty = amount === 'Buy Gift Card';
  const href = isEmpty ? ROUTES.giftCardsShop : ROUTES.giftCards;

  return (
    <Flex
      align='center'
      width='100%'
      backgroundColor={giftCardBlock.bg}
      borderBottomRadius={6}
      borderTopRadius={isAlternativeVariant ? 0 : 6}
      p='15px'
      marginBottom='18px'
    >
      <Box
        position='relative'
        width='74px'
        height='50px'
        overflow='hidden'
        borderRadius='5px'
        flexShrink={0}
        alignContent='center'
      >
        <Image
          src={image}
          alt={title}
          width={74}
          height={50}
          style={{ objectFit: 'contain', borderRadius: '5px' }}
          sizes='(max-width: 450px) 75px, 200px'
        />
      </Box>

      <Stack
        w='100%'
        h='100%'
        gap='10px'
        alignItems='center'
        justifyContent='space-between'
        marginLeft='16px'
        _hover={{
          'a:hover': {
            opacity: 0.7
          }
        }}
      >
        <Text
          textAlign='center'
          fontSize='11px'
          textTransform='uppercase'
          marginBottom='auto'
          color={giftCardBlock.textHeaderColor}
        >
          {title}
        </Text>
        <Link
          href={href}
          style={{
            fontSize: 22,
            lineHeight: '120%',
            pointerEvents: 'auto',
            fontWeight: 600,
            textDecoration: 'none',
            color: giftCardBlock.textContentColor
          }}
        >
          {giftCardText ? amount : formatCurrency(String(amount))}
        </Link>
      </Stack>
    </Flex>
  );
};

export default GiftCardBlock;
